define(['EventEmitter'], function (EventEmitter) {
    var mediator;
    var guardian = window.guardian;
    var app = guardian.app = guardian.app || {};

    if (app.mediator) {
        return app.mediator;
    }

    // a singleton instance of EventEmitter across the app
    mediator = new EventEmitter();
    app.mediator = mediator;

    return mediator;
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/common/utils/mediator.js
// module id = 1
// module chunks = 13